(function() {
    'use strict';

    angular.module('aprima-provider-api').factory('FncRepository', [
        'AprimaAnalytics',
        'AprimaRestangular',
        FncRepository
    ]);

    function FncRepository(
        AprimaAnalytics,
        AprimaRestangular
    ) {
        return {
            getClinicalNotes: getClinicalNotes,
            getContext: getContext,
            createVisitFromAppt: createVisitFromAppt,
            getAuthCode: getAuthCode,
        };

        function getClinicalNotes(providerId) {
            var timing = AprimaAnalytics.startTiming('FncRepository', 'api', 'getClinicalNotes');
            var restangular = AprimaRestangular.get();
            return restangular
                .all('fnc/clinicalnotetypes/' + providerId)
                .getList()
                .finally(timing.stop);
        }

        function getContext(patientId, visitId) {
            var timing = AprimaAnalytics.startTiming('FncRepository', 'api', 'getContext');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('patients/' + patientId + '/fnc/' + visitId + '/context')
                .get()
                .finally(timing.stop);
        }

        function createVisitFromAppt(appointmentId, clinicalNoteTypeId) {
            var timing = AprimaAnalytics.startTiming('FncRepository', 'api', 'createVisitFromAppt');
            var restangular = AprimaRestangular.get();
            return restangular
                .all('fnc')
                .post({
                    AppointmentId: appointmentId,
                    ClinicalNoteTypeId: clinicalNoteTypeId,
                })
                .finally(timing.stop);
        }

        function getAuthCode(patientCaseId, visitDate) {
            var timing = AprimaAnalytics.startTiming('FncRepository', 'api', 'getAuthCode');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('fnc/patientcases', patientCaseId)
                .customGET('authorizationcode', {
                    visitDate: visitDate,
                })
                .finally(timing.stop);
        }
    }
})();